/* ui/game/configuration/SlimeConfiguration.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_input_value,
	space,
	to_number
} from "svelte/internal";

import {
	game,
	defaultConfig,
	configuration,
	configurationStore,
	GRID_SIZE
} from "../../store";

function add_css() {
	var style = element("style");
	style.id = "svelte-1o1hhp2-style";
	style.textContent = ".container.svelte-1o1hhp2{display:grid;grid-template-columns:1fr 1fr;grid-gap:5px}.header.svelte-1o1hhp2{display:grid;justify-content:center;align-content:center}label.svelte-1o1hhp2{grid-column:1;white-space:nowrap}input.svelte-1o1hhp2{grid-column-start:3;width:4em;font-size:.7em}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div0;
	let t1;
	let div1;
	let label0;
	let t3;
	let input0;
	let t4;
	let label1;
	let t6;
	let input1;
	let t7;
	let label2;
	let t9;
	let input2;
	let t10;
	let label3;
	let t12;
	let input3;
	let mounted;
	let dispose;

	return {
		c() {
			div0 = element("div");
			div0.innerHTML = `<h4>Slime Configuration</h4>`;
			t1 = space();
			div1 = element("div");
			label0 = element("label");
			label0.textContent = "Initial Slimes";
			t3 = space();
			input0 = element("input");
			t4 = space();
			label1 = element("label");
			label1.textContent = "Min Level to Split";
			t6 = space();
			input1 = element("input");
			t7 = space();
			label2 = element("label");
			label2.textContent = "XP Percentage on Split";
			t9 = space();
			input2 = element("input");
			t10 = space();
			label3 = element("label");
			label3.textContent = "HP Percentage on Split";
			t12 = space();
			input3 = element("input");
			attr(div0, "class", "header svelte-1o1hhp2");
			attr(label0, "class", "svelte-1o1hhp2");
			attr(input0, "type", "number");
			attr(input0, "min", "1");
			attr(input0, "max", GRID_SIZE);
			attr(input0, "class", "svelte-1o1hhp2");
			attr(label1, "class", "svelte-1o1hhp2");
			attr(input1, "type", "number");
			attr(input1, "min", "1");
			attr(input1, "max", "12");
			attr(input1, "class", "svelte-1o1hhp2");
			attr(label2, "class", "svelte-1o1hhp2");
			attr(input2, "type", "number");
			attr(input2, "min", "1");
			attr(input2, "max", "100");
			attr(input2, "class", "svelte-1o1hhp2");
			attr(label3, "class", "svelte-1o1hhp2");
			attr(input3, "type", "number");
			attr(input3, "min", "1");
			attr(input3, "max", "100");
			attr(input3, "class", "svelte-1o1hhp2");
			attr(div1, "class", "container svelte-1o1hhp2");
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			insert(target, t1, anchor);
			insert(target, div1, anchor);
			append(div1, label0);
			append(div1, t3);
			append(div1, input0);
			set_input_value(input0, /*initialSlimes*/ ctx[0]);
			append(div1, t4);
			append(div1, label1);
			append(div1, t6);
			append(div1, input1);
			set_input_value(input1, /*minSplitLevel*/ ctx[1]);
			append(div1, t7);
			append(div1, label2);
			append(div1, t9);
			append(div1, input2);
			set_input_value(input2, /*splitXpPercentage*/ ctx[2]);
			append(div1, t10);
			append(div1, label3);
			append(div1, t12);
			append(div1, input3);
			set_input_value(input3, /*splitHpPercentage*/ ctx[3]);

			if (!mounted) {
				dispose = [
					listen(input0, "input", /*input0_input_handler*/ ctx[5]),
					listen(input0, "change", /*reset*/ ctx[4]),
					listen(input1, "input", /*input1_input_handler*/ ctx[6]),
					listen(input1, "change", /*reset*/ ctx[4]),
					listen(input2, "input", /*input2_input_handler*/ ctx[7]),
					listen(input2, "change", /*reset*/ ctx[4]),
					listen(input3, "input", /*input3_input_handler*/ ctx[8]),
					listen(input3, "change", /*reset*/ ctx[4])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*initialSlimes*/ 1 && to_number(input0.value) !== /*initialSlimes*/ ctx[0]) {
				set_input_value(input0, /*initialSlimes*/ ctx[0]);
			}

			if (dirty & /*minSplitLevel*/ 2 && to_number(input1.value) !== /*minSplitLevel*/ ctx[1]) {
				set_input_value(input1, /*minSplitLevel*/ ctx[1]);
			}

			if (dirty & /*splitXpPercentage*/ 4 && to_number(input2.value) !== /*splitXpPercentage*/ ctx[2]) {
				set_input_value(input2, /*splitXpPercentage*/ ctx[2]);
			}

			if (dirty & /*splitHpPercentage*/ 8 && to_number(input3.value) !== /*splitHpPercentage*/ ctx[3]) {
				set_input_value(input3, /*splitHpPercentage*/ ctx[3]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div0);
			if (detaching) detach(t1);
			if (detaching) detach(div1);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { initialSlimes, minSplitLevel, splitXpPercentage, splitHpPercentage } = defaultConfig.slime;

	function reset() {
		const slime = {
			initialSlimes,
			minSplitLevel,
			splitXpPercentage,
			splitHpPercentage
		};

		configurationStore.update(configuration => ({ ...configuration, slime }));
		game.reset();
	}

	function input0_input_handler() {
		initialSlimes = to_number(this.value);
		$$invalidate(0, initialSlimes);
	}

	function input1_input_handler() {
		minSplitLevel = to_number(this.value);
		$$invalidate(1, minSplitLevel);
	}

	function input2_input_handler() {
		splitXpPercentage = to_number(this.value);
		$$invalidate(2, splitXpPercentage);
	}

	function input3_input_handler() {
		splitHpPercentage = to_number(this.value);
		$$invalidate(3, splitHpPercentage);
	}

	return [
		initialSlimes,
		minSplitLevel,
		splitXpPercentage,
		splitHpPercentage,
		reset,
		input0_input_handler,
		input1_input_handler,
		input2_input_handler,
		input3_input_handler
	];
}

class SlimeConfiguration extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1o1hhp2-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default SlimeConfiguration;